module.exports = __webpack_public_path__ + "static/img/img_cabinet.bcf93fa8.png";